export function SkeletonLoader({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4">
          {Array.from({ length: cols }).map((_, j) => (
            <div
              key={j}
              className="flex-1 h-12 bg-gradient-to-r from-gray-200 to-gray-100 rounded-lg animate-pulse"
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export function SkeletonCard() {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-4">
      <div className="h-8 bg-gradient-to-r from-gray-200 to-gray-100 rounded w-1/3 animate-pulse" />
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded animate-pulse" />
        ))}
      </div>
    </div>
  )
}

export const SkeletonGrid = SkeletonCard
export const SkeletonTable = SkeletonLoader
